export const ADD_SALARY_REQUEST = "ADD_SALARY_REQUEST";
export const ADD_SALARY_SUCCESS = "ADD_SALARY_SUCCESS";
export const ADD_SALARY_FAILURE = "ADD_SALARY_FAILURE";

export const GET_FILTERED_SALARIES_REQUEST = "GET_FILTERED_SALARIES_REQUEST";
export const GET_FILTERED_SALARIES_SUCCESS = "GET_FILTERED_SALARIES_SUCCESS";
export const GET_FILTERED_SALARIES_FAILURE = "GET_FILTERED_SALARIES_FAILURE";

export const RESET_SALARY = "RESET_SALARY";
